import { Container } from '@material-ui/core';
import React from 'react';
import Logo from 'components/atoms/Logo/Logo';
import styled from 'styled-components';
import BoxWrapper from 'components/atoms/BoxWrapper';
import HeaderTypography from 'components/atoms/HeaderTypography';
import { Link } from 'react-router-dom';
import { routes } from 'routes/Routes';

const StyledHeaderContainer = styled(Container)`
    padding: 0;
    background-color: ${({ theme }) => theme.palette.primary.header};
    border-radius: 0 0 20px 20px;
    display: flex !important;

    flex-direction: ${({ pathname }) => (pathname === '/' ? 'column' : 'row-reverse')}!important;
    align-items: center;
`;

const Header = ({ title }) => {
    const currentLocation = window.location.pathname;
    return (
        <StyledHeaderContainer>
            <Link to={routes.homeRoute}>
                <Logo />
            </Link>
            <BoxWrapper>
                <HeaderTypography variant="h2" pathname={currentLocation}>
                    {title}
                </HeaderTypography>
            </BoxWrapper>
        </StyledHeaderContainer>
    );
};

export default Header;
